"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateTimestamp = exports.setSteps = exports.setPrevPage = exports.setModalSize = exports.setIcons = exports.setDynamicPageContent = exports.openGuidedSellingModal = exports.openFloater = exports.goToRecommendationErrorPage = exports.goToDynamicPage = exports.closeGuidedSellingModal = exports.closeFloater = exports.UPDATE_TIME_STAMP = exports.UPDATE_LOADER_TEXT = exports.SET_STEPPER_STEPS = exports.SET_PREV_PAGE = exports.SET_MODAL_SIZE = exports.SET_ICON = exports.SET_DYNAMIC_PAGE_CONTENT = exports.OPEN_GUIDED_SELLING_MODAL = exports.OPEN_FLOATER = exports.LOADING = exports.GO_TO_RECOMMENDATION_ERROR_PAGE = exports.GO_TO_DYNAMIC_PAGE = exports.CLOSE_GUIDED_SELLING_MODAL = exports.CLOSE_FLOATER = void 0;
const LOADING = 'LOADING';
exports.LOADING = LOADING;
const UPDATE_LOADER_TEXT = 'UPDATE_LOADER_TEXT';
exports.UPDATE_LOADER_TEXT = UPDATE_LOADER_TEXT;
const OPEN_GUIDED_SELLING_MODAL = 'OPEN_GUIDED_SELLING_MODAL';
exports.OPEN_GUIDED_SELLING_MODAL = OPEN_GUIDED_SELLING_MODAL;
const CLOSE_GUIDED_SELLING_MODAL = 'CLOSE_GUIDED_SELLING_MODAL';
exports.CLOSE_GUIDED_SELLING_MODAL = CLOSE_GUIDED_SELLING_MODAL;
const UPDATE_TIME_STAMP = 'UPDATE_TIME_STAMP';
exports.UPDATE_TIME_STAMP = UPDATE_TIME_STAMP;
const SET_MODAL_SIZE = 'SET_MODAL_SIZE';
exports.SET_MODAL_SIZE = SET_MODAL_SIZE;
const GO_TO_DYNAMIC_PAGE = 'GO_TO_DYNAMIC_PAGE';
exports.GO_TO_DYNAMIC_PAGE = GO_TO_DYNAMIC_PAGE;
const SET_DYNAMIC_PAGE_CONTENT = 'SET_DYNAMIC_PAGE_CONTENT';
exports.SET_DYNAMIC_PAGE_CONTENT = SET_DYNAMIC_PAGE_CONTENT;
const GO_TO_RECOMMENDATION_ERROR_PAGE = 'GO_TO_RECOMMENDATION_ERROR_PAGE';
exports.GO_TO_RECOMMENDATION_ERROR_PAGE = GO_TO_RECOMMENDATION_ERROR_PAGE;
const SET_PREV_PAGE = 'SET_PREV_PAGE';
exports.SET_PREV_PAGE = SET_PREV_PAGE;
const OPEN_FLOATER = 'OPEN_FLOATER';
exports.OPEN_FLOATER = OPEN_FLOATER;
const CLOSE_FLOATER = 'CLOSE_FLOATER';
exports.CLOSE_FLOATER = CLOSE_FLOATER;
const SET_ICON = 'SET_ICON';
exports.SET_ICON = SET_ICON;
const SET_STEPPER_STEPS = 'SET_STEPPER_STEPS';
exports.SET_STEPPER_STEPS = SET_STEPPER_STEPS;
const openGuidedSellingModal = () => ({
  type: OPEN_GUIDED_SELLING_MODAL
});
exports.openGuidedSellingModal = openGuidedSellingModal;
const closeGuidedSellingModal = () => ({
  type: CLOSE_GUIDED_SELLING_MODAL
});
exports.closeGuidedSellingModal = closeGuidedSellingModal;
const openFloater = () => ({
  type: OPEN_FLOATER
});
exports.openFloater = openFloater;
const closeFloater = closedBy => ({
  type: CLOSE_FLOATER,
  payload: closedBy
});
exports.closeFloater = closeFloater;
const updateTimestamp = updatedTimeStamp => ({
  type: UPDATE_TIME_STAMP,
  payload: updatedTimeStamp
});
exports.updateTimestamp = updateTimestamp;
const setModalSize = size => ({
  type: SET_MODAL_SIZE,
  payload: {
    size
  }
});
exports.setModalSize = setModalSize;
const setPrevPage = page => ({
  type: SET_PREV_PAGE,
  payload: page
});
exports.setPrevPage = setPrevPage;
const goToDynamicPage = () => ({
  type: GO_TO_DYNAMIC_PAGE
});
exports.goToDynamicPage = goToDynamicPage;
const setDynamicPageContent = contentKey => ({
  type: SET_DYNAMIC_PAGE_CONTENT,
  payload: {
    contentKey
  }
});
exports.setDynamicPageContent = setDynamicPageContent;
const goToRecommendationErrorPage = () => ({
  type: GO_TO_RECOMMENDATION_ERROR_PAGE
});
exports.goToRecommendationErrorPage = goToRecommendationErrorPage;
const setIcons = icons => ({
  type: SET_ICON,
  payload: icons
});
exports.setIcons = setIcons;
const setSteps = journrySteps => ({
  type: SET_STEPPER_STEPS,
  payload: {
    journrySteps
  }
});
exports.setSteps = setSteps;